import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core';

import { ProtectInnerTextDirective } from '../../../directives/protect-inner-text/protect-inner-text.directive';
import { SharedConfigService } from '../../../services/config/config.service';
import { TranslatePipe } from '../../../services/i18n/i18n.module';

@Component({
  selector: 'ol[shared-footer-menu]',
  imports: [
    TranslatePipe,
    ProtectInnerTextDirective,
  ],
  templateUrl: './footer-menu.html',
  styleUrl: './footer-menu.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'menu',
    '[attr.data-direction]': 'direction()',
  },
})
export class AppFooterMenuComponent {
  #configService = inject(SharedConfigService);

  readonly direction = input<'row' | 'column'>('row');

  protected menu = ['security', 'privacy', 'terms_of_use'] as const;

  protected useOneTrust = computed<boolean>(() => {
    const scriptId = this.#configService.get('ONE_TRUST_SCRIPT_ID');

    return scriptId && scriptId !== '';
  });
}
